import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";
import { respond } from "@api/contactMessages/respond/path";

const pathBase = `/contact-messages/`;
const pathById = `${pathBase}/:contactId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const contactMessages = {
  getAll: apiPathFunc(pathBase),
  get: apiPathFunc(pathById),
  respond,
} as const;
